<template>
    <div class="alert alert-danger mt-3 mb-5">
        <div class="container" v-html="lang.polaris.training.delete_registration_warning"></div>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                lang: lang
            }
        }

    }
</script>
